/*!
 * Music Forecast — プレイヤーバーの商品導線
 *
 *  1. ジャケット（60 × 60）を商品ページへのリンクにする ……… 全幅共通
 *  2. 商品名のリンクを「リンクだと分かる」見え方にする ……… 全幅共通
 *     商品ページの Label: と同じ「常時うす下線・hover で濃く」に揃える
 *  3. 追加ボタン「＋ ¥2,750」 …………………………… 750px 以上だけ
 *     モバイルはバーに余白が無い（商品名の領域が 73px しか無く既に切れている）ため出さない
 *     750px という境界は、プレイヤー自身が使っている max-width:749px に合わせたもの
 *
 * 置き場所 : テーマ → コードを編集 → Assets → mf-player-link.js
 * 読み込み : layout/theme.liquid の </body> 直前に
 *            <script src="{{ 'mf-player-link.js' | asset_url }}" defer></script>
 *
 * 元に戻す : その1行を消すだけ。既存の CSS / JS は書き換えていない
 * 調べる   : window.mfPlayerLinkDebug = true
 */
(function () {
  'use strict';
  if (window.__mfPlayerLink) return;
  window.__mfPlayerLink = true;

  var BP = 750;            // これ未満ではカートボタンを出さない
  var cache = {};          // handle → 商品データ
  var current = null;      // いまバーに出ている商品

  /* ---------------------------------------------------------------- 見た目 */

  var CSS = [
    /* 1. ジャケットのリンク */
    'a.mf-thumb-link{display:flex;flex:0 0 auto;align-items:center;text-decoration:none;',
    '  transition:opacity .15s;outline-offset:-2px}',
    'a.mf-thumb-link:hover{opacity:.82}',
    'a.mf-thumb-link:focus-visible{outline:2px solid #161819}',
    'a.mf-thumb-link:not([href]){pointer-events:none}',

    /* 2. 商品名のリンク（商品ページの Label: と同じ作法）
       プレイヤー本体の <style> は body 側にあり、こちらより後ろに置かれる。
       同じ詳細度だと向こうの
         .mf-info__product a{color:inherit;text-decoration:none}
       が勝ってしまうため、#mf-player を足して詳細度を上げている */
    '#mf-player .mf-info__product{line-height:1.5;padding:2px 0}',
    '#mf-player .mf-info__product a{color:#6a6a6a;text-decoration:underline;',
    '  text-decoration-thickness:1px;text-underline-offset:3px;',
    '  text-decoration-color:rgba(22,24,25,.28);',
    '  transition:color .15s,text-decoration-color .15s}',
    '#mf-player .mf-info__product a:hover{color:#161819;text-decoration-color:currentColor}',
    '#mf-player .mf-info__product a:focus-visible{outline:2px solid #161819;outline-offset:2px}',

    /* 3. 追加ボタン（750px 以上）
       記号と数字だけにしてある。ヘッダーのカートアイコンと意味が衝突せず、
       日本語ページでも英語ページでも同じものが出る */
    '.mf-cart{display:none;align-items:center;gap:.55em;height:32px;padding:0 11px;margin-right:10px;',
    '  flex:0 0 auto;border:1px solid rgba(22,24,25,.32);background:transparent;color:#161819;',
    '  cursor:pointer;font:inherit;font-size:11px;letter-spacing:.1em;white-space:nowrap;',
    '  transition:background-color .14s,color .14s,border-color .14s}',
    '@media (min-width:' + BP + 'px){.mf-cart.is-ready{display:inline-flex}}',
    '.mf-cart:hover{background:#161819;color:#fff;border-color:#161819}',
    '.mf-cart:focus-visible{outline:2px solid #161819;outline-offset:2px}',
    '.mf-cart svg{width:10px;height:10px;fill:none;stroke:currentColor;stroke-width:1.4;',
    '  stroke-linecap:round;flex:0 0 auto;display:block}',
    '.mf-cart__price{font-variant-numeric:tabular-nums;letter-spacing:.04em;font-size:11.5px}',
    '.mf-cart__sold{letter-spacing:.14em;text-transform:uppercase;font-size:10px}',
    /* 売り切れ・処理中・完了・失敗 */
    '.mf-cart.is-sold{border-color:rgba(22,24,25,.16);color:#b5b5b5;pointer-events:none}',
    '.mf-cart.is-busy{opacity:.5;pointer-events:none}',
    '.mf-cart.is-done{background:#161819;color:#fff;border-color:#161819}',
    '.mf-cart.is-error{border-color:#c0392b;color:#c0392b}',
    '.mf-cart.is-error:hover{background:transparent;color:#c0392b}',
    '@media (prefers-reduced-motion:reduce){.mf-cart,a.mf-thumb-link{transition:none}}'
  ].join('');

  var st = document.createElement('style');
  st.id = 'mf-player-link';
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);

  /* ---------------------------------------------------------------- 部品 */

  var PLUS  = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.4v9.2M1.4 6h9.2"/></svg>';
  var CHECK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1.6 6.4 4.5 9.3 10.4 2.9"/></svg>';

  /* 画面に出る文字は記号と金額と SOLD OUT だけなので翻訳は要らない。
     読み上げ用のラベルだけ言語を見る */
  var EN = !!(window.Shopify && String(window.Shopify.locale || '').slice(0, 2) === 'en');
  var T = {
    add:   EN ? 'Add to cart' : 'カートに追加',
    sold:  EN ? 'Sold out' : '売り切れ',
    added: EN ? 'Added to cart' : 'カートに追加しました',
    error: EN ? 'Could not add to cart. Please try again.' : 'カートに追加できませんでした。もう一度お試しください'
  };

  function log() { if (window.mfPlayerLinkDebug) console.log.apply(console, ['[mf-player-link]'].concat([].slice.call(arguments))); }

  /* 通貨を換算している市場では金額を出さない。誤った数字を見せるより出さない方が良い */
  function money(cents) {
    var c = window.Shopify && window.Shopify.currency;
    if (!c || String(c.rate) !== '1.0') return '';
    try { return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: c.active || 'JPY',
      maximumFractionDigits: 0 }).format(cents / 100); } catch (e) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
  }

  function handleOf(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) { v = p.variants[i]; break; }
        cache[handle] = { id: v ? v.id : null, price: v ? v.price : (p.variants[0] || {}).price, available: !!v, title: p.title };
        return cache[handle];
      });
  }

  /* ---------------------------------------------------------------- 組み立て */

  function build(player) {
    var bar = player.querySelector('.mf-bar');
    var thumb = player.querySelector('.mf-thumb');
    var right = player.querySelector('.mf-right');
    var nameBox = player.querySelector('.mf-info__product');
    if (!bar || !thumb || !nameBox) return;

    /* 1. ジャケットを <a> で包む（ノードは作り替えない。プレイヤーが参照を持っているため） */
    var link = player.querySelector('a.mf-thumb-link');
    if (!link) {
      link = document.createElement('a');
      link.className = 'mf-thumb-link';
      thumb.parentNode.insertBefore(link, thumb);
      link.appendChild(thumb);
    }

    /* 3. カートボタン */
    var cart = player.querySelector('.mf-cart');
    if (!cart && right) {
      cart = document.createElement('button');
      cart.type = 'button';
      cart.className = 'mf-cart';
      cart.innerHTML = '<span class="mf-cart__mark">' + PLUS + '</span><span class="mf-cart__price"></span>';
      bar.insertBefore(cart, right);
      cart.addEventListener('click', add);
    }

    function sync() {
      var a = nameBox.querySelector('a');
      var href = a ? a.getAttribute('href') : null;
      if (href) {
        link.setAttribute('href', href);
        link.setAttribute('aria-label', (a.textContent || '').trim());
      } else {
        link.removeAttribute('href');
        link.removeAttribute('aria-label');
      }

      if (!cart) return;
      var h = handleOf(href);
      if (!h) { cart.classList.remove('is-ready'); current = null; return; }
      if (current && current.handle === h) return;

      current = { handle: h };
      cart.classList.remove('is-done', 'is-busy');
      load(h).then(function (d) {
        if (!current || current.handle !== h) return;      // 曲が変わっていたら捨てる
        current.id = d.id;
        render(d);
        cart.classList.add('is-ready');
        log('sync', h, d);
      }).catch(function (e) { cart.classList.remove('is-ready'); log('load failed', h, e); });
    }

    /* 在庫あり → 「＋ ¥2,750」／ 売り切れ → 「SOLD OUT」
       通貨を換算している市場では金額を出さないので「＋」だけになる */
    function render(d) {
      var mark = cart.querySelector('.mf-cart__mark');
      var price = cart.querySelector('.mf-cart__price');
      cart.classList.toggle('is-sold', !d.available);
      if (d.available) {
        mark.innerHTML = PLUS;
        mark.hidden = false;
        price.className = 'mf-cart__price';
        price.textContent = money(d.price);
        cart.setAttribute('aria-label', T.add + ': ' + d.title);
        cart.setAttribute('title', T.add);
      } else {
        mark.hidden = true;
        price.className = 'mf-cart__sold';
        price.textContent = 'SOLD OUT';
        cart.setAttribute('aria-label', T.sold + ': ' + d.title);
        cart.removeAttribute('title');
      }
    }

    function add() {
      if (!current || !current.id) return;
      cart.classList.remove('is-error');
      cart.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          var h = current ? current.handle : null;
          cart.classList.remove('is-busy');
          cart.classList.add('is-done');
          cart.querySelector('.mf-cart__mark').innerHTML = CHECK;
          cart.querySelector('.mf-cart__price').textContent = '';
          cart.setAttribute('aria-label', T.added);
          // 件数の更新もドロワーの開閉もテーマ側が行う
          document.body.dispatchEvent(new CustomEvent('label:modalcart:afteradditem', { bubbles: true }));
          setTimeout(function () {
            cart.classList.remove('is-done');
            if (current && current.handle === h && cache[h]) render(cache[h]);
          }, 1600);
        })
        .catch(function (e) {
          cart.classList.remove('is-busy');
          cart.classList.add('is-error');
          cart.setAttribute('title', T.error);
          cart.setAttribute('aria-label', T.error);
          setTimeout(function () {
            cart.classList.remove('is-error');
            if (current && cache[current.handle]) render(cache[current.handle]);
          }, 2600);
          log('add failed', e);
        });
    }

    sync();
    new MutationObserver(sync).observe(nameBox, { childList: true, subtree: true, characterData: true });
    log('ready');
  }

  /* プレイヤーは最初の再生で作られるので、現れるまで待つ */
  function start() {
    var p = document.getElementById('mf-player');
    if (p) { build(p); return; }
    var mo = new MutationObserver(function () {
      var el = document.getElementById('mf-player');
      if (el) { mo.disconnect(); build(el); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();